"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _react = require("react");

var _useDebounce = require("use-debounce");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Debounce validations errors until the user stops providing input.
 * ex.
 * ...
 * const [debouncedErrors, updateErrors] = useDebouncedErrors(errors)
 *
 * return (
 *   <>
 *     <div>{debouncedErrors}</div>
 *     <input onChange={() => updateErrors()} />
 *    </>
 * )
 */
function _default(errors, delay = 500) {
  const [debouncedErrors, setDebouncedErrors] = (0, _react.useState)(null);
  const [updateErrors, _, callPending] = (0, _useDebounce.useDebouncedCallback)(() => {
    setDebouncedErrors(errors);
  }, delay); // If errors changes, schedule an update
  // @ts-ignore

  (0, _react.useEffect)(() => updateErrors(errors), [errors, updateErrors]); // If there's no more errors, short circuit so we can display immediately

  if ((0, _isNil.default)(errors)) {
    callPending();
  }

  return [debouncedErrors, updateErrors];
}